import {useGoogleService} from '@/composables'
import axios from 'axios'

export default function useLocation() {
  const settings = {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 0,
  }
  const googleApiEndpoint =
    'https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBHuCioOrHD5vHTdnnhzWTQiikVk6Rgp8c'

  async function getGoogleLocation() {
    const response = await axios.post(
      googleApiEndpoint,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    if (response.status >= 200 && response.status < 400) {
      const {data} = response
      const {
        accuracy,
        location: {lat: latitude, lng: longitude},
      } = data
      try {
        const {getAddressUsingCoordinates} = useGoogleService()
        const address = await getAddressUsingCoordinates(latitude, longitude)
        return {latitude, longitude, accuracy, address, source: 'google'}
      } catch (error) {
        return {latitude, longitude, accuracy, source: 'google'}
      }
    }
  }

  async function getBrowserLocation() {
    const {getAddressUsingCoordinates} = useGoogleService()
    return new Promise((resolve, reject) => {
      let watcher
      watcher = navigator.geolocation.watchPosition(
        async position => {
          navigator.geolocation.clearWatch(watcher)
          const {coords} = position
          const {latitude, longitude, accuracy} = coords
          try {
            const address = await getAddressUsingCoordinates(latitude, longitude)
            resolve({latitude, longitude, accuracy, address, source: 'browser'})
          } catch (error) {
            resolve({latitude, longitude, accuracy, source: 'browser'})
          }
        },
        error => {
          reject(error)
        },
        settings
      )
    })
  }

  async function getLocation() {
    try {
      return await getBrowserLocation()
    } catch (error) {
      // GeolocationPositionError code 1 is PERMISSION_DENIED; 2 (unavailable) and
      // 3 (timeout) are not permission problems, so the IP-based fallback location
      // must not be reported as a denied permission.
      const denied = error?.code === 1
      const location = await getGoogleLocation()
      if (!location) throw error
      return {...location, denied}
    }
  }

  return {
    getLocation,
  }
}
